module.exports = __webpack_public_path__ + "static/media/effectivity-image.9be9063e.png";